// rescontrolcambios.schema.ts

import * as yup from 'yup';
const DOMINIOS_PERMITIDOS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'yahoo.com',
  'fibramax.ec',
];
export const responsableSchema = yup.object({
  responsableId: yup.string().optional(),
  cargo: yup
    .string()
    .required('El cargo es obligatorio')
    .matches(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'Solo se permiten letras y espacios'),
  usuarioId: yup
    .number()
    .typeError('El usuario es obligatorio')
    .required('El usuario es obligatorio'),
  correo: yup
  .string()
  .required('El correo es obligatorio')
  .email('Debe ingresar un correo válido')
  .test(
    'dominio-permitido',
    `Solo se permiten correos con los dominios: ${DOMINIOS_PERMITIDOS.join(', ')}`,
    (value) => {
      if (!value) return false;

      const dominio = value.split('@')[1]?.toLowerCase();

      // return dominiosPermitidos.includes(dominio);
      return DOMINIOS_PERMITIDOS.includes(dominio);
    }
  ),
  telefono: yup
    .string()
    .required('El teléfono es obligatorio')
    .matches(/^09\d{8}$/, 'Ingrese un número de celular válido de Ecuador (ej. 0991234567)'),
  estado: yup.boolean().required(),
});
